import React, { useState } from 'react';
import styled from 'styled-components';
import { Loader2, Button, SelectInput, ModalConfirm } from 'components';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import picto_copy from 'images/picto_copy.svg';
import axios from 'axios';
import picto_unwrap from 'images/picto_unwrap.svg';
import picto_roll_up from 'images/picto_roll_up.svg';
import set from 'lodash.set';

const Container = styled.div`
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	gap: 10px;
	margin-top: 20px;

	h2 {
		display: flex;
		flex-direction: row;
		gap: 20px;
	}
	
	h3 {
		margin: 0 !important;
	}

	div.borders {
		border: 1px solid ${props => props.theme.placeholderColor};
		border-radius: 5px;
		padding: 10px;
		max-width: 100%;
		overflow-x: auto;
	}

	.select_container__api {
		width: 230px;
	}

	label {
		color: ${props => props.theme.darkBlue};
		font-size: 16px;
		font-weight: 500;
		line-height: normal;
		width: 265px;
	}

`;

const Row = styled.div`
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 10px;
	width: 100%;
	position: relative;
	overflow: visible;
	
	@media (min-width: 660px) {
		flex-direction: row;
		gap: 20px;
		justify-content: space-between;
	}
`;

const RowM = styled.div`
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 10px;
	position: relative;
	overflow: visible;
	
	> * {
		display: flex;
		flex-direction: row;
		gap: 8px;
	}
	
	@media (min-width: 660px) {
		flex-direction: row;
		align-items: center;
		gap: 20px;
	}

	a, a.active {
		color: ${props => props.theme.darkBlue} !important;
		font-family: "PT Sans";
	}
`;

const ScrollBox = styled.div`
	height:150px;
	min-height: 150px;
	overflow-y: auto;
	overflow-x: auto;
	flex-shrink: 0;
	flex-grow: 1;
	flex-basis: 10px;
	border: 1px solid ${props => props.theme.placeholderColor};
	border-radius: 5px;
	padding: 5px 0px 5px 5px;
	max-width: 100%;
`;

const Block = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	flex-shrink: 0;
	flex-grow: 1;
	flex-basis: 10px;
`;

const defaultParams = {
	CompanyId: '',
	UserType: '',
	UserId: '',
	Password: '',
	Language: 'ru',
	CountryCode: '',
	CountryName: '',
	CityCode: '',
	CityName: '',
	Opt: '',
};

export const RequestFormCityList = () => {
	const { t } = useTranslation();
	const [ sResponse, setResponse ] = useState('');
	const [ isOpened, setIsOpened ] = useState(false);
	const [ loading, setLoading ] = useState(false);
	const [ params, setParams ] = useState({ ...defaultParams });
	const [ api, setApi ] = useState('TEST');
	const [ confirmProps, setConfirmProps ] = useState({});


	const apiOptions = [
		{ value: 'TEST', label: t('на тестовой системе') },
		{ value: 'PROD', label: t('на продуктиве!') },
	];

	const apiBind = {
		value: apiOptions.find(i => i.value === api) ?? null,
		options: apiOptions,
		onChange: option => {
			setApi(option.value);
		},
		name: 'api'
	};

	const onChange = (name, value) => {
		if (Array.isArray(name) && name.length > 0) {
			setParams(prev => {
				const data = JSON.parse(JSON.stringify(prev));
				name.forEach(i => set(data, i.name, i.value));
				return { ...data };
			});
		} else if (name !== undefined && value !== undefined) {
			setParams(prev => {
				const data = JSON.parse(JSON.stringify(prev));
				set(data, name, value);
				return { ...data };
			});
		}
	};

	const CompanyIdBind = {
		value: params.CompanyId,
		onChange: e => onChange('CompanyId', e.target.value),
	};

	const UserIdBind = {
		value: params.UserId,
		onChange: e => onChange('UserId', e.target.value),
	};

	const PasswordBind = {
		value: params.Password,
		onChange: e => onChange('Password', e.target.value),
		type: 'password',
	};

	const LanguageBind = {
		value: params.Language,
		onChange: e => onChange('Language', e.target.value),
	};

	const CountryCodeBind = {
		value: params.CountryCode,
		onChange: e => onChange('CountryCode', e.target.value),
	};

	const CountryNameBind = {
		value: params.CountryName,
		onChange: e => onChange('CountryName', e.target.value),
	};

	const CityCodeBind = {
		value: params.CityCode,
		onChange: e => onChange('CityCode', e.target.value),
	};

	const CityNameBind = {
		value: params.CityName,
		onChange: e => onChange('CityName', e.target.value),
	};

	const OptBind = {
		value: params.Opt,
		onChange: e => onChange('Opt', e.target.value),
	};

	const getRequest = () => {

		if (api === 'PROD') {
			setConfirmProps({
				isVisible: true,
				title: t('Внимание!'),
				text: t('Метод будет выполнен на продуктивной системе! Вы уверены?'),
				onConfirm: () => {
					runRequest(true);
					setConfirmProps(false);
				},
				onCancel: () => setConfirmProps(false),
			});
		}
		else {	
			runRequest();
		}

	};

	const runRequest = () => {

		setLoading(true);

		axios.post(
			api === 'TEST' ? '/rapi00' : '/rapi99',
			{
				'RequestName': 'CityListRequest',
				'UserType': 'BUYER',
				'CompanyId': params.CompanyId,
				'UserId': params.UserId,
				'Password': params.Password,
				'Language': params.Language,
				'CountryCode': params.CountryCode,
				'CountryName': params.CountryName,
				'CityCode': params.CityCode,
				'CityName': params.CityName,
				'Opt': params.Opt,
			},
			{
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
				}
			}
		)
			.then(resp => resp.data)
			.then(data => {
				setResponse(data);
				setLoading(false);
			});


	};

	const onCopy = async () => {
		try {
			await navigator.clipboard.writeText(sResponse);
		} catch (error) {
			console.error(error.message);
		}
	};

	const onOpen = () => {
		setIsOpened(!isOpened);
	};

	return (
		<Container>
			<RowM>
				<h2>{t('Выполнить метод')}</h2>
				<div><SelectInput {...apiBind} /></div>
			</RowM>

			<RowM>
				<label>{t('Идентификатор организации')} <div style={{color: 'red'}}>*</div></label>
				<Block>
					<input {...CompanyIdBind} />
				</Block>
			</RowM>

			<RowM>
				<label>{t('Идентификатор пользователя')} <div style={{color: 'red'}}>*</div></label>
				<Block>
					<input {...UserIdBind} />
				</Block>
			</RowM>

			<RowM>
				<label>{t('Пароль')} <div style={{color: 'red'}}>*</div></label>
				<Block>
					<input {...PasswordBind} />
				</Block>
			</RowM>

			<RowM>
				<label>{t('Язык выдачи информации')} <div style={{color: 'red'}}>*</div></label>
				<Block>
					<input {...LanguageBind} />
				</Block>
			</RowM>

			<RowM>
				<label>{t('Код страны')}</label>
				<Block>
					<input {...CountryCodeBind} />
				</Block>
			</RowM>

			<RowM>
				<label>{t('Наименование страны')}</label>
				<Block>
					<input {...CountryNameBind} />
				</Block>
			</RowM>

			<RowM>
				<label>{t('Код города')}</label>
				<Block>
					<input {...CityCodeBind} />
				</Block>
			</RowM>

			<RowM>
				<label>{t('Наименование города')}</label>
				<Block>
					<input {...CityNameBind} />
				</Block>
			</RowM>

			<RowM>
				<label>{t('Дополнительные параметры')}</label>
				<Block>
					<input {...OptBind} />
				</Block>
			</RowM>

			<Row>
				<div></div>
				<Button gradient onClick={getRequest}>{t('Отправить')}</Button>
			</Row>

			{loading && <Loader2 />}

			{sResponse?.length > 0 && <>
				<div className='col-1 margin-bottom-20' />
				<Row>
					<h3>{t('Ответ')}</h3>
					<RowM>
						<NavLink rel="noreferrer" onClick={onCopy}>
							<img src={picto_copy} alt="" /> {t('Копировать')}</NavLink>
						<NavLink rel="noreferrer" onClick={onOpen}>
							<img src={isOpened ? picto_roll_up : picto_unwrap} alt="" />
							{isOpened ? t('Свернуть') : t('Развернуть')}</NavLink>
					</RowM>
				</Row>

				{ isOpened ?
					<div className='borders'>
						<pre>
							{sResponse}
						</pre>
					</div>
					:
					<ScrollBox>
						<pre>
							{sResponse}
						</pre>
					</ScrollBox>
				}
			</>}

			<ModalConfirm {...confirmProps} />

		</Container>
	);
};
